import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Row, Col, Container, Button } from "react-bootstrap";
import { sanitizeUrl } from "@braintree/sanitize-url";

import RightArrow from "../../assets/images/right-arrow-white.svg";
import Carousel1 from "../../assets/images/MFA-Background-001.png";
import Tick from "../../assets/images/tick.svg";
import Notick from "../../assets/images/failure.png";
import downChevron from "../../assets/images/down-chevron.svg";

class Preview extends Component {
    constructor(props) {
        super(props);
        this.state = {
            seeMore:false,
            paramState: '',
            screen: 0,
            tickImage: [{'image': Tick},{'image': Notick}],
            refIdParam: '',
            gotoParam: ''
        }
    }

    componentDidMount() {  

        let queryParam = new URLSearchParams(window.location.search);
        let refId = queryParam.get('refId');
        if(refId){
            this.setState({
                refIdParam: refId,
            });
        }
        let goto = queryParam.get('goto');
        if(goto){
            this.setState({
                gotoParam: goto,
            });
        }
        let URLstate = queryParam.get('state');
        this.setState({
            paramState: URLstate,
        });
        let status = queryParam.get('status');
        let error_code = queryParam.get('error');
        let result = queryParam.get('verificationResult');
        if(status === 'COMPLETE') {
            if(result === 'pass') {                
                this.setState({
                    screen: 1,
                });
            }
            else if(result == 'reject') {
                 this.setState({
                    screen: 3,
                });
            }
        }
        else if(status === 'ERROR') {
            if(error_code === 'CANCEL') {                
                this.setState({
                    screen: 4,
                });
            }
            else {
                this.setState({
                    screen: 2,
                });
            }
        }
    } 

    seeMoreHandler = () => {
      this.setState({
        seeMore: !this.state.seeMore,
      });
    };

    reloadPage = () => {
        window.location.reload();
    }

    moveNext = () => {
        window.history.replaceState({}, document.title, window.location.pathname);
        const locationUrl = window.location.origin;
        let nextURL = `/ctidentity/idverification`;
            if(this.state.paramState) {
              nextURL = `/ctidentity/idverification?state=` + this.state.paramState + `&goto=` + this.state.gotoParam + `&refId=` + this.state.refIdParam;
            }
            else {
            nextURL = `/ctidentity/idverification?` + `goto=` + this.state.gotoParam + `&refId=` + this.state.refIdParam;
            } 
        //this.props.history.push(nextURL);
        window.location.replace(sanitizeUrl(`${locationUrl}${nextURL}`));
     } 

    render() {
        const { t } = this.props;
        const {
            seeMore,
            screen,
            tickImage
        } = this.state;
        return (
             <div style={{flexGrow:1}}>
                <div className="wrapper register verification" style={{ backgroundImage: `url(${Carousel1})` }}>
                    <Container className={`container wrapper__container`}>
                        <Row>
                            {
                                screen === 0 &&
                                (                                    
                                    <Col lg={{ span: 5 }} className="next-container">
                                        <div className="wrapper__container-card wrapper__header">
                                        <div className="wrapper__container-card-body">
                                            <h1 className="wrapper__container-card-body-title" tabIndex={0} role="heading">{t("pages.idVerification.welcome")}</h1>
                                            <Button
                                                className="wrapper__container-card-body-submit"
                                                size="lg"
                                                variant="primary"
                                                block
                                                type="submit"
                                                aria-label={t("pages.identity.continue")}
                                                onClick={() => {
                                                    this.moveNext()
                                                }}
                                                onKeyDown={(e) => 
                                                    {
                                                    if(e.key === 'Enter') {
                                                        this.moveNext()
                                                    }
                                                    }}
                                                tabIndex={0} role="button" 
                                            >
                                                {t("pages.identity.continue")}
                                                <img src={RightArrow} alt="" />
                                            </Button>
                                            </div>
                                        </div>
                                    </Col>
                                )
                            }
                             {
                                screen === 1 &&
                                (                                    
                                    <Col lg={{ span: 6 }} className="next-container">
                                        <div className="wrapper__container-card">
                                        <div className="wrapper__container-card-body">
                                        <div className="image-text"  style={{marginTop:`120px`,}}>
                                            <div clasName="right" style={{padding: 0}}>
                                            <h1 className="wrapper__container-card-body-title" style={{ textAlign: `center`}}>{t("pages.idVerification.idSuccess")}</h1>
                                            <p style={{textAlign:`center`, marginBottom:`0`}}
                                                >{t("pages.idVerification.identitySuccess")}</p>
                                            <img src={tickImage[0].image} alt="" style={{width:`66px`, margin: `0 auto`, display: 'block'}}/>  
                                            </div>
                                            <Button
                                            className="wrapper__container-card-body-submit"
                                            size="lg"
                                            variant="primary"
                                            block
                                            type="submit"
                                            aria-label= {t("pages.identity.continue")}
                                            onClick={this.reloadPage}
                                            >
                                                {t("pages.identity.continue")}
                                                <img src={RightArrow} alt="" />
                                                </Button>
                                            </div>
                                        </div>
                                        </div>
                                    </Col>
                                )
                            }
                             {
                                screen === 2 &&
                                (                                    
                                  <Col lg={{ span: 6 }} className="next-container">
                                    <div className="wrapper__container-card">
                                        <div className="wrapper__container-card-body">
                                    <div className="image-text"  style={{marginTop:`120px`,}}>
                                        <div clasName="right" style={{padding: 0}}>
                                            <h1 className="wrapper__container-card-body-title" style={{ textAlign: `center`}}>{t("pages.pageNotFound.title")}</h1>
                                            <p style={{textAlign:`center`, width: `90%`, margin: `0 auto`, marginBottom:`0`}}
                                            >{t("pages.idVerification.internalFailure")}</p>                                            
                                            <img src={tickImage[1].image} alt="" style={{width:`66px`, margin: `0 auto`, display: 'block'}}/>  
                                        </div>
                                        <Button
                                            className="wrapper__container-card-body-submit"
                                            size="lg"
                                            variant="primary"
                                            block
                                            type="submit"
                                            aria-label= {t("pages.idVerification.retry")}
                                            onClick={this.reloadPage}
                                        >
                                            {t("pages.idVerification.retry")}
                                            <img src={RightArrow} alt="" />
                                        </Button>
                                    </div>
                                </div>
                                    </div>
                                </Col>
                                )
                            }
                            {
                                screen === 3 &&
                                 (
                                    <Col lg={{ span: 6 }} className="next-container">
                                        <div className="wrapper__container-card">
                                            <div className="wrapper__container-card-body">
                                            <div className="image-text"  style={{marginTop:`120px`,}}>
                                                <div clasName="right" style={{padding: 0}}>
                                                <h1 className="wrapper__container-card-body-title" style={{ textAlign: `center`}}>{t("pages.idVerification.idFailure")}</h1>    
                                                <p style={{textAlign: `center`, marginLeft: `34px`, marginBottom:`0`}}
                                                    >{t("pages.idVerification.identityDocFailure")}</p>
                                                <img src={tickImage[1].image} alt="" style={{width:`66px`, margin: `0 auto`, display: 'block'}}/> 
                                                </div>
                                                <Button
                                                    className="wrapper__container-card-body-submit"
                                                    size="lg"
                                                    variant="primary"
                                                    block
                                                    type="submit"
                                                    onClick={this.reloadPage}
                                                    aria-label={t("pages.identity.continue")}
                                                >
                                                    {t("pages.identity.continue")}
                                                    <img src={RightArrow} alt="" />
                                                </Button>
                                            </div>
                                        </div>
                                        </div>
                                    </Col>
                                 )
                            }
                            {
                                screen === 4 &&
                                 (
                                    <Col lg={{ span: 6 }} className="next-container">
                                        <div className="wrapper__container-card">
                                            <div className="wrapper__container-card-body"></div>
                                            <div style={{padding: 0}}>
                                                <h1 className="wrapper__container-card-body-title" style={{ textAlign: `center`}}>{t("pages.pageNotFound.title")}</h1>
                                                <p style={{textAlign:`center`, width: `90%`, margin: `0 auto`, marginBottom:`0`}}>{t("pages.levelTwo.cancelTransaction")}</p>
                                                <img src={tickImage[1].image} alt="" style={{width:`66px`, margin: `0 auto`, display: 'block'}}/>  
                                            </div>
                                            <Button
                                                className="wrapper__container-card-body-submit"
                                                size="lg"
                                                variant="primary"
                                                block
                                                type="submit"
                                                aria-label= {t("pages.idVerification.retry")}
                                                onClick={this.reloadPage}
                                            >
                                                {t("pages.idVerification.retry")}
                                                <img src={RightArrow} alt="" />
                                            </Button>
                                        </div>
                                    </Col>
                                )
                            }
                            <Col lg={{ span: 6 }} className="register-right-content">    
                                <div className="register__right-container">                      
                                <div className="register__right-container-heading ">{t("pages.idVerification.rightHead")} </div>
                                    <div className={seeMore ? "show" : ""}>
                                        <p>{t("pages.idVerification.rightContent")}</p>
                                        <div className="hide">
                                            <p>{t("pages.idVerification.rightContentOne")}</p>
                                            <p><a className="register__right-container-link" tabIndex={0} role="link" aria-label={t("pages.idVerification.rightLink")} href="https://portal.ct.gov/ctidentity/id-verification-faq?language=en_US" target="_blank">{t("pages.idVerification.rightLink")}</a></p> 
                                        </div>                          
                                        </div>
                                        <p
                                            className={
                                            seeMore ? "open see-more mt-3" : "see-more mt-3"
                                            }
                                            aria-label=""
                                            tabIndex={0}
                                            role="button"
                                            onClick={this.seeMoreHandler}
                                            onKeyPress={this.seeMoreHandler}
                                        >
                                            <span className="more">{t("pages.login.seeMore")}</span>
                                            <span className="less">{t("pages.login.seeLess")}</span>
                                            <img src={downChevron} alt="down-chevron"></img>
                                        </p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>   
        )
    }
}

export default withTranslation()(Preview);